// CRUX DARK home carousel alignment v6 — DARK home only.
(() => {
  const sectionSuffixes = [
    '__product_list_dark_best_sellers_20260805','__product_list_YKgLnG','__product_list_dDJabg',
    '__product_list_j6LkqL','__product_list_hxjBxc','__product_list_7Ed46A','__product_list_bkkMtc','__product_list_pwUrU4'
  ];
  const arrowCenterVariable = '--crux-dark-carousel-arrow-center-offset';
  const align = () => {
    if (document.body.dataset.cruxWorld !== 'dark' || document.querySelector('#MainContent')?.dataset.template !== 'page.cthulhu') return;
    for (const suffix of sectionSuffixes) {
      const section = document.querySelector('[id$="' + suffix + '"]');
      if (!section) continue;
      const carousel = section.querySelector('slideshow-component.resource-list__carousel');
      const arrows = carousel?.querySelector(':scope > slideshow-container > slideshow-arrows');
      const media = [...(carousel?.querySelectorAll('product-card img') || [])].find((image) => image.getBoundingClientRect().width > 0)
        || carousel?.querySelector('product-card .product-media-container, product-card .card-gallery');
      if (!arrows || !media) continue;
      const arrowsRect = arrows.getBoundingClientRect();
      const mediaRect = media.getBoundingClientRect();
      const centerOffset = mediaRect.top + mediaRect.height / 2 - (arrowsRect.top + arrowsRect.height / 2);
      arrows.style.setProperty(arrowCenterVariable, centerOffset + 'px');
      for (const button of arrows.querySelectorAll(':scope > .slideshow-control')) {
        button.style.removeProperty('top');
        button.style.setProperty('transform', 'translateY(var(' + arrowCenterVariable + '))', 'important');
      }
    }
  };
  const run = () => { align(); requestAnimationFrame(align); setTimeout(align, 350); };
  document.addEventListener('DOMContentLoaded', run, { once: true });
  window.addEventListener('load', run, { once: true });
  window.addEventListener('resize', run, { passive: true });
  document.addEventListener('shopify:section:load', run);
})();
